import './js/API';
import './js/authentication/form';


// import './js/handlers/bookCategory';
// import './js/handlers/markup-category-list';

import './js/shoppingList';

import './js/test/mobileMenu';
import './js/test/swiper-supportUkraine';

import './js/header/index';

import './js/switcher-theme-fn';
// 